
import React, { useEffect, useState } from 'react';
import { Col, Row, Card, Skeleton } from 'antd';
import { FaPlane } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { getFlightDomesticList, getFlightInternationalList } from '../../../services/flight/flightServices';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { airlineAssets } from './AirlineAssetsConfig';

const FlightSection = ({ title, flights, onSelect, loading, initialAirline }) => {
    if (loading) return <Skeleton active />;
    return (
        <>
            <div className="section-title mb-3">
                <h3>{title}</h3>
            </div>
            {flights?.map((flight) => (
                <Card className='mb-2'>
                    <Row gutter={20} className="gx-lg-5 gx-3 gy-4 align-items-md-center flight-details-cntr">
                        <Col md={5} xs={12} className='mb-2 mb-xl-0' style={{ order: '-1' }}>
                            <div className="d-flex align-items-center justify-content-start">
                                {airlineAssets[initialAirline] && (
                                    <div className="d-start fl-pic">
                                        <img
                                            className="img-collection result-flight rounded"
                                            src={airlineAssets[initialAirline].logo}
                                            alt={`${airlineAssets[initialAirline]} logo`}
                                            style={{ width: "40px", height: "40px" }}
                                        />
                                    </div>
                                )}

                                <div className="d-end fl-title ps-2">
                                    <div className="text-dark fw-medium">{initialAirline}</div>
                                </div>
                            </div>
                        </Col>

                        <Col md={14} xs={24} className='mt-md-0 mt-1'>
                            <Row gutter={16} className="row gx-3 align-items-center">
                                <Col md={6}>
                                    <div className="text-dark fw-bold lh-sm">{flight.from_city}</div>
                                </Col>

                                <Col flex="auto" className="text-center">
                                    <div className="flightLine departure" style={{ top: "0px" }}>
                                        <FaPlane className='flight-takeoff' />
                                        <div></div>
                                        <div></div>
                                    </div>
                                </Col>

                                <Col md={6}>
                                    <div className="text-dark fw-bold lh-sm">{flight.to_city}</div>
                                </Col>
                            </Row>
                        </Col>

                            {/* this is commented price section */}
                        {/* <Col md={4} xs={12} className='mt-0 text-end'>
                            <h3 className='fw-bold'>₹2000</h3>
                        </Col> */}

                        <Col md={5} xs={12} className='mt-0 order--1'>
                            <div className="d-xl-flex items-center justify-content-between w-100 h-100">
                                <div className="d-xl-block d-none border br-dashed me-4"></div>
                                <div className='d-flex flex-wrap d-xl-block justify-content-end align-items-center xlMargin'>
                                    <button
                                        type="primary"
                                        onClick={() => onSelect(flight)}
                                        className='btn btn-primary menu-block px-4 mt-xl-1'
                                        aria-label="Book now"
                                    >
                                        Select
                                    </button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card>
            ))}
        </>
    );
};

const PopularAirlineFlights = ({ initialAirline }) => {
    const [domesticData, setDomesticData] = useState([]);
    const [internationalData, setInternationalData] = useState([]);
    const [loading, setLoading] = useState({ domestic: true, international: true });
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const formattedTomorrow = moment().add(1, 'days').format('DD/MMM/YYYY');

    const fetchDomesticData = async () => {
        try {
            setLoading(prev => ({ ...prev, domestic: true }));
            const data = await getFlightDomesticList();
            setDomesticData(data?.data || []);
        } catch (err) {
            setError('Failed to fetch domestic flights');
        } finally {
            setLoading(prev => ({ ...prev, domestic: false }));
        }
    };

    const fetchInternationalData = async () => {
        try {
            setLoading(prev => ({ ...prev, international: true }));
            const data = await getFlightInternationalList();
            setInternationalData(data?.data || []);
        } catch (err) {
            setError('Failed to fetch international flights');
        } finally {
            setLoading(prev => ({ ...prev, international: false }));
        }
    };

    useEffect(() => {
        fetchDomesticData();
        fetchInternationalData();
    }, []);

    const handleFlightClick = (flight) => {
        sessionStorage.setItem('selectFromCity', JSON.stringify(flight?.from_city));
        sessionStorage.setItem('selectFromCityName', JSON.stringify(flight?.from_city_airport));
        sessionStorage.setItem('selectTOCity', JSON.stringify(flight?.to_city));
        sessionStorage.setItem('selectTOCityName', JSON.stringify(flight?.to_city_airport));
        sessionStorage.setItem('seatTypeflight', JSON.stringify("ECONOMY"));
        sessionStorage.setItem('returnFlight', JSON.stringify('oneWay'));
        sessionStorage.setItem("airlineName", JSON.stringify(initialAirline));
        sessionStorage.setItem('DepartureFlight', JSON.stringify(formattedTomorrow));
        sessionStorage.setItem('selectAdultsflight', JSON.stringify(1));
        sessionStorage.setItem('selectChildflight', JSON.stringify(0));
        sessionStorage.setItem('selectInfantsflight', JSON.stringify(0));
        const formattedFromCity = flight?.from_city?.toLowerCase().replace(/\s+/g, '-');
        const formattedToCity = flight?.to_city?.toLowerCase().replace(/\s+/g, '-');
        const urlIdDynamic = `${formattedFromCity}-to-${formattedToCity}-flights`;
        navigate(`/flights/${urlIdDynamic}`);
    };



    return (
        <section className="flight-area SpiceJet-flight-area pt-5 pb-5">
            <div className="container">
                <Row gutter={20} className="gy-4">
                    <Col md={18} flex="1 0 auto">
                        <FlightSection
                            title={`${initialAirline} Domestic Flights`}
                            flights={domesticData?.slice(0, 9)}
                            onSelect={handleFlightClick}
                            loading={loading.domestic}
                            initialAirline={initialAirline}
                        />
                        <br /><br />
                        <FlightSection
                            title={`${initialAirline} International Flights`}
                            flights={internationalData}
                            onSelect={handleFlightClick}
                            loading={loading.international}
                            initialAirline={initialAirline}
                        />
                    </Col>

                    {airlineAssets[initialAirline]?.sideBanner && (
                        <Col md={6} className="d-none d-md-block">
                            <img
                                src={airlineAssets[initialAirline]?.sideBanner}
                                className="img-fluid rounded"
                                alt={airlineAssets[initialAirline].alt}
                                style={{ position: "sticky", top: "100px" }}
                            />
                        </Col>
                    )}

                </Row>
            </div>
        </section>
    );
};

export default PopularAirlineFlights;
